export default {
  type: {
    label: 'À quel endroit va pouvoir stationner le camion ?',
    options: {
      publicParkingSpace: 'Place de stationnement publique',
      placeOfDelivery: 'Place de livraison',
      privateParkingSpace: 'Place de stationnement privée',
      doubleParked: 'En double file',
      sidewalk: 'Sur le trottoir',
      busLane: 'Sur voie de bus',
    },
  },
  portage: {
    label: 'À quelle distance de votre logement se trouve ce lieu de stationnement ?',
    specify: 'Précisez cette distance :',
    options: {
      first: '< 10m',
      second: '10 - 20m',
      third: '20 - 30m',
      fourth: '30 - 40m',
      fifth: '40 - 50m',
      sixth: '> 50m',
    },
  },
  vl: {
    label: 'Un camion poids lourd peut-il stationner à cet endroit ?',
  },
};
